// External modules
import { useStoreState } from '@/store';

export const useButtonCurrencyCode = (): string => {
  const conversionData = useStoreState(({ api }) => api.currencyConversionData);

  const selection = useStoreState(({ form }) => {
    return form.currencyConversionSelection;
  });

  // Checking `from` prop because the default for the currency conversion data
  // is an empty object, which is truthy, so we can't just check `if (!data)`
  if (!conversionData?.from) {
    return '';
  }

  const conversionType = selection === 'VENDOR' ? 'to' : 'from';
  return conversionData[conversionType]?.currencyCode;
};
